import React, { ChangeEvent, FormEvent } from 'react';
import Icon from '@mdi/react';
import { mdiMagnify, mdiDotsVertical } from '@mdi/js';
import DropdownButton, { DropdownButtonItem } from '../../components/DropdownButton';

const dropdownItems = [
  { title: 'Clear history', value: 0 },
  { title: 'Logout', value: 1 },
];

interface AISearchProps {
  onChange: (question: string) => void;
  onClearHistory: () => void;
  onLogout: () => void;
}

export default function AISearch({ onChange, onClearHistory, onLogout }: AISearchProps) {
  const [value, setValue] = React.useState('');
  const [dropdown, setDropdown] = React.useState(false);

  const handleDropdownClick = () => {
    setDropdown(!dropdown);
  };

  const handleDropdownItemClick = (item: DropdownButtonItem) => {
    if (item.value === 0) onClearHistory();
    else onLogout();

    setDropdown(false);
  };

  const handleSubmit = async (evt: FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    onChange(value);
    setValue('');
  };

  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    setValue(evt.target.value);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="ai-searchbox">
        <Icon path={mdiMagnify} size="20px" />
        <input type="search" placeholder="Ask a question regarding Flip features" value={value} onChange={handleChange} />
      </div>
      <button type="submit">Ask</button>
      <DropdownButton open={dropdown} items={dropdownItems} onClick={handleDropdownItemClick}>
        <button className="secondary" type="button" aria-label="More options" onClick={handleDropdownClick}>
          <Icon path={mdiDotsVertical} size="20px" />
        </button>
      </DropdownButton>
    </form>
  );
}
